import { Injectable, inject } from '@angular/core';
import { act, Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';
import { HttpBaseService } from 'src/app/base/http-base.service';
import {
  getDataModel,
  setDataModel,
  deleteDataModel,
  updateDataModel,
  saveDataModel,
  setTreeOrder,
  setAllDataModelTables,
  getAllDataModelTables,
  saveTableData,
  updateTableData,
  saveDatamodelData,
  updateDatamodelData,
  deleteDatamodelData,
  deleteTableData,
  updateDataModelTreeOrder,
  saveDatamodelDataSuccess,
  saveDatamodelDataFailure,
  setComplexTypeTables,
  getComplexTypeTables,
  saveDatamodelTableSuccess,
  saveDatamodelTableFailure,
  saveDatamodelTreeFailure,
  saveDatamodelTreeSuccess,
  saveTableFldData,
  getScripts,
  getForeignKey,
  setForeignKey,
  updateForeignKey,
  deleteForeignKey,
  deletedFKId,
  deleteFKFailure,
  deleteFKSuccess,
  updateFKFailure,
  updateFKSuccess,
  getAllForeignKeys,
  setAllForeignKeys,
  saveAppDatamodelBatch,
  getLookUpTables,
  setLookUpTables
} from '../actions/datamodel.actions';
import { GlobalConstants } from 'src/app/base/global.constants';
import { setAllPropertiesData } from '../actions/propertypane.actions';

@Injectable()
export class DataModelEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);

  getAllDataModelTables$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getAllDataModelTables),
        map((action) => {
          if (!action.datamodelApiConstants) {
            return;
          }
          return this.baseService[action.datamodelApiConstants?.method](
            action.datamodelApiConstants,
            GlobalConstants.dataTableHeaders
          ).subscribe((result: any) => {
            this.store.dispatch(
              setAllDataModelTables({
                allDataModelTables: result
              })
            );
          });
        })
      ),
    { dispatch: false }
  );
  getLookUpTable$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getLookUpTables),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.params).subscribe(
            (lookUpTables: any) => {
              //console.log(propertiesValues);
              if (lookUpTables) {
                this.store.dispatch(setLookUpTables({ lookUpTables: lookUpTables }));
              } else {
                this.store.dispatch(setLookUpTables({ lookUpTables: null }));
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getDataModel),
        map((action: any) => {
          this.baseService.get(action.initialProperties).subscribe((results: any) => {
            this.store.dispatch(
              setDataModel({
                datamodelData: {
                  tableInfo: null,
                  initialProperties: results,
                  data: null
                }
              })
            );
            this.store.dispatch(setAllPropertiesData({ allProperties: results }));
          });
          // return combineLatest([
          //   this.baseService.get(action.tableInfo.options, action.tableInfo.params),
          //   this.baseService.get(action.initialProperties)
          // ]).subscribe((results: any) => {
          //   console.log(results)
          //   this.store.dispatch(setDataModel({
          //     datamodelData: {
          //       tableInfo: results[0],
          //       initialProperties: results[1],
          //       data: results[0]
          //     }
          //   }));
          //   if (results[0]) {
          //     this.store.dispatch(setTreeOrder({
          //       treeOrder: results[0]
          //     }))
          //   } else {
          //     this.store.dispatch(setTreeOrder({
          //       treeOrder: null
          //     }))
          //   }
          // })
        })
      ),
    { dispatch: false }
  );

  deleteDataModel$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteDataModel),
        map((action) => this.baseService.delete(action, action.datamodelId))
      ),
    { dispatch: false }
  );

  updateDataModel$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateDataModel),
        map((action) => {
          if (!action.datamodelData?.data) {
            return;
          }
          this.store.dispatch(saveDatamodelTreeSuccess({ treeResults: null }));
          this.store.dispatch(saveDatamodelTreeFailure({ treeError: null }));
          this.baseService[action.datamodelApiConstants?.method](
            action.datamodelApiConstants,
            action.datamodelData?.data
          ).subscribe(
            (results: any) => {
              this.store.dispatch(saveDatamodelTreeSuccess({ treeResults: results }));
            },
            (err: any) => {
              this.store.dispatch(saveDatamodelTreeFailure({ treeError: err }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  saveDataModel$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveDataModel),
        map((action) =>
          this.baseService[action.apiConstants?.method](action.apiConstants, action.datamodelData.data).subscribe(
            (result: any) => {
              this.store.dispatch(
                setDataModel({
                  datamodelData: {
                    data: result,
                    tableInfo: result
                  }
                })
              );
            }
          )
        )
      ),
    { dispatch: false }
  );

  saveTableData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveTableData),
        map((action) => {
          this.store.dispatch(saveDatamodelTableSuccess({ tableResults: null }));
          this.store.dispatch(saveDatamodelTableFailure({ tableError: null }));
          this.baseService[action.datamodelApiConstants?.method](
            action.datamodelApiConstants,
            action.tableData
          ).subscribe(
            (results: any) => {
              this.store.dispatch(saveDatamodelTableSuccess({ tableResults: results }));
            },
            (err: any) => {
              this.store.dispatch(saveDatamodelTableFailure({ tableError: err }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  saveTableFldData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveTableFldData),
        map((action) => {
          this.baseService[action.datamodelApiConstants?.method](
            action.datamodelApiConstants,
            action.tableFldData
          ).subscribe(
            (results: any) => {
              this.store.dispatch(saveDatamodelTreeSuccess({ treeResults: results }));
            },
            (err: any) => {
              this.store.dispatch(saveDatamodelTreeFailure({ treeError: err }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  updateTableData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateTableData),
        map((action) => {
          this.baseService[action.datamodelApiConstants?.method](
            action.datamodelApiConstants,
            action.tableData
          ).subscribe(
            (results: any) => {
              this.store.dispatch(saveDatamodelTableSuccess({ tableResults: results }));
            },
            (err: any) => {
              this.store.dispatch(saveDatamodelTableFailure({ tableError: err }));
            }
          );
        })
      ),
    { dispatch: false }
  );
  saveFieldData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveDatamodelData),
        map((action) => {
          this.store.dispatch(saveDatamodelDataSuccess({ results: null }));
          this.store.dispatch(saveDatamodelDataFailure({ error: null }));
          this.baseService[action.datamodelApiConstants?.method](
            action.datamodelApiConstants,
            action.fieldData
          ).subscribe(
            (results: any) => {
              this.store.dispatch(saveDatamodelDataSuccess({ results }));
            },
            (err: any) => {
              this.store.dispatch(saveDatamodelDataFailure({ error: err }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  updateFieldData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateDatamodelData),
        map((action) => {
          this.store.dispatch(saveDatamodelDataSuccess({ results: null }));
          this.store.dispatch(saveDatamodelDataFailure({ error: null }));
          this.baseService[action.datamodelApiConstants?.method](
            action.datamodelApiConstants,
            action.fieldData
          ).subscribe(
            (results: any) => {
              this.store.dispatch(saveDatamodelDataSuccess({ results }));
            },
            (err: any) => {
              this.store.dispatch(saveDatamodelDataFailure({ error: err }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  deleteDataModelData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteDatamodelData),
        map((action) =>
          this.baseService[action.datamodelApiConstants?.method](
            action.datamodelApiConstants,
            action.fieldId
          ).subscribe((result: any) => {
            console.log(result);
          })
        )
      ),
    { dispatch: false }
  );

  deleteTableData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteTableData),
        map((action) =>
          this.baseService[action.datamodelApiConstants?.method](
            action.datamodelApiConstants,
            action.tableId
          ).subscribe((result: any) => {
            console.log(result);
          })
        )
      ),
    { dispatch: false }
  );

  saveAppDatamodelBatch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveAppDatamodelBatch),
        map((action) => {
          this.store.dispatch(saveDatamodelTreeSuccess({ treeResults: null }));
          this.store.dispatch(saveDatamodelTreeFailure({ treeError: null }));
          this.baseService[action.batchApiConstants?.method](action.batchApiConstants, action.data).subscribe(
            (results: any) => {
              this.store.dispatch(saveDatamodelTreeSuccess({ treeResults: results }));
            },
            (err: any) => {
              this.store.dispatch(saveDatamodelTreeFailure({ treeError: { err: err, actionData: action.data } }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  // Save Document Data
  generateScripts$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getScripts),
        map((action: any) => {
          return this.baseService[action.rdbmsScriptApiConstants?.method](
            action.rdbmsScriptApiConstants,
            action.params
          ).subscribe((response: any) => {
            console.log('hello');
          });
        })
      ),
    {
      dispatch: false
    }
  );

  updateFieldOrder$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateDataModelTreeOrder),
        map((action) => {
          this.baseService[action.datamodelApiConstants?.method](
            action.datamodelApiConstants,
            action.orderInfo
          ).subscribe();
        })
      ),
    { dispatch: false }
  );

  getComplexDataTypes$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getComplexTypeTables),
        map((action) => {
          if (!action.datamodelApiConstants) {
            return;
          }
          return this.baseService[action.datamodelApiConstants?.method](
            action.datamodelApiConstants,
            action.params
          ).subscribe((result: any) => {
            this.store.dispatch(
              setComplexTypeTables({
                complexTypeTables: result
              })
            );
          });
        })
      ),
    { dispatch: false }
  );

  updateForeignKey$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateForeignKey),
      map((action) => {
        this.baseService[action.updfkapiConstants?.method](action.updfkapiConstants, action.foreignKeyData).subscribe((result: any) => {
          if (result) {
            try {
              this.store.dispatch(setForeignKey({ foreignKeyTbl: JSON.parse(result) }));
            }
            catch (e) {
              this.store.dispatch(setForeignKey({ foreignKeyTbl: [] }));
            }
            this.store.dispatch(updateFKSuccess({ fKSaveSuccess: result }));
          }
        }, (err) => {
          this.store.dispatch(updateFKFailure({ fKSaveFailure: err }));
        })
      })),
    { dispatch: false }
  );


  getForeignKey$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getForeignKey),
      map((action) => {
        if (!action.fkapiConstants) return;
        return this.baseService[action.fkapiConstants?.method](action.fkapiConstants, action.data).subscribe((result: any) => {
          if (result) {
            this.store.dispatch(setForeignKey({
              foreignKeyTbl: result
            }))
          } else {
            this.store.dispatch(setForeignKey({
              foreignKeyTbl: []
            }))
          }
        })
      })),
    { dispatch: false }
  );

  deleteForeignKey$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteForeignKey),
      map((action) => this.baseService[action.delApiConstants?.method](action.delApiConstants, action.data).subscribe((result: any) => {
        this.store.dispatch(deletedFKId({ fkId: action.data.foreignKeyId }));
        this.store.dispatch(deleteFKSuccess({ fkDelSuccess: action.data.foreignKeyId }));
      }, (err) => {
        this.store.dispatch(deleteFKFailure({ fkDelFailure: err }));
      }))
    ),
    { dispatch: false }
  );


  getAllForeignKeys$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getAllForeignKeys),
      map((action) => {
        if (!action.fkallapiConstants) return;
        return this.baseService[action.fkallapiConstants?.method](action.fkallapiConstants).subscribe((result: any) => {
          if (result) {
            this.store.dispatch(setAllForeignKeys({
              allForeignKeys: result
            }))
          } else {
            this.store.dispatch(setAllForeignKeys({
              allForeignKeys: []
            }))
          }
          return this.baseService[action.fkallapiConstants?.method](action.fkallapiConstants).subscribe(
            (result: any) => {
              if (result) {
                this.store.dispatch(
                  setAllForeignKeys({
                    allForeignKeys: result
                  })
                );
              } else {
                this.store.dispatch(
                  setAllForeignKeys({
                    allForeignKeys: []
                  })
                );
              }
            }
          );
        })
      })),
    { dispatch: false }
  );
}
